/**
 * Swiper 10.2.0
 * @url : https://swiperjs.com/api/
 *
 * Residences slider & his version with filters
 * To display only a selected amount of residences
 */
// import Swiper JS
// core version + navigation, pagination, freemode & keyboard modules:
import Swiper from 'swiper';
import { Navigation, Keyboard, Pagination } from 'swiper/modules';

const resSlider = Array.from(document.getElementsByClassName('js-swiper-residences'));
const filterBtns = Array.from(document.getElementsByClassName('js-filter-slide'));

if (resSlider.length) {
  for (const swiper of resSlider){
    // Swiper instance
    const swiperInstance = new Swiper(swiper, {
      modules: [Navigation, Pagination, Keyboard],
      grabCursor: true,
      slidesPerView: 'auto',
      speed: 700,
      pagination: {
        el:  swiper.querySelector('.swiper-pagination'),
        clickable: true
      },
      keyboard: true,
      init: false
    })

    // Init only if there is 2 or more slides
    const nbSlides = Array.from(swiper.getElementsByClassName('swiper-slide'));

    if (nbSlides.length > 1 && !filterBtns.length) {
      swiperInstance.init();
    }

    // If filters are present we know we have more than 1 item
    if (filterBtns.length) {
      swiperInstance.on('init', function () {
        // On init, the first filter is active
        slidesFiltering(filterBtns[0], filterBtns, swiperInstance);
      });

      swiperInstance.init();

      filterBtns.forEach((btn) => {
        btn.addEventListener('click', function () {
          slidesFiltering(btn, filterBtns, swiperInstance);
        });
      });
    }
  }
}


function slidesFiltering(el, filters, slider) {
  for (const btn of filters) {
    btn.classList.remove('active');
  }

  el.classList.add('active');

  const activeFilter = el.dataset.location;
  const allSlides = slider.slides;

  for (const slide of allSlides) {
    const slideFilterAttr = slide.dataset.location;

    if (activeFilter === slideFilterAttr) {
      slide.classList.remove('hide');
    } else {
      slide.classList.add('hide');
    }
  }

  slider.update();
}


